// Resumable uploads from the browser (same /uploads API the app uses for big camera files): sends the file in
// parts, resumes from the server's offset after a dropped connection, and reports progress.
import { getToken } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api";
const auth = () => { const t = getToken(); return t ? { Authorization: "Bearer " + t } : {}; };
async function j(res) { const d = await res.json().catch(() => ({})); if (!res.ok && res.status !== 409) throw new Error(d.detail || "Upload failed"); return { status: res.status, data: d }; }

export async function uploadFile(file, { kind = "post", onProgress } = {}) {
  const start = await j(await fetch(BASE + "/uploads/start", { method: "POST", headers: { "Content-Type": "application/json", ...auth() },
    body: JSON.stringify({ filename: file.name || "upload", content_type: file.type || "application/octet-stream", size: file.size, kind }) }));
  const id = start.data.upload_id;
  const chunk = start.data.chunk_size || 8 * 1024 * 1024;
  let offset = 0;
  let tries = 0;
  while (offset < file.size) {
    try {
      const r = await j(await fetch(BASE + "/uploads/" + id + "?offset=" + offset, { method: "PUT", headers: { "Content-Type": "application/octet-stream", ...auth() }, body: file.slice(offset, offset + chunk) }));
      offset = r.data.offset ?? offset;
      tries = 0;
      if (onProgress) onProgress(Math.round((offset / file.size) * 100));
    } catch (e) {
      if (++tries > 4) throw e;
      await new Promise((ok) => setTimeout(ok, 800 * tries));
      const s = await j(await fetch(BASE + "/uploads/" + id, { headers: auth() }));
      offset = s.data.offset ?? offset;
    }
  }
  const done = await j(await fetch(BASE + "/uploads/" + id + "/complete", { method: "POST", headers: auth() }));
  if (done.status === 409) {
    for (let i = 0; i < 60; i += 1) {
      await new Promise((ok) => setTimeout(ok, 2000));
      const s = await j(await fetch(BASE + "/uploads/" + id, { headers: auth() }));
      if (s.data.status === "done") return s.data.result;
      if (s.data.status === "failed") throw new Error(s.data.error || "Upload failed");
    }
    throw new Error("Still processing — check back in a minute");
  }
  return done.data;
}

export async function downloadAuthed(path, filename) {
  const res = await fetch(BASE + path, { headers: auth() });
  if (!res.ok) throw new Error("Couldn't download");
  const a = document.createElement("a"); a.href = URL.createObjectURL(await res.blob()); a.download = filename; a.click();
}
